module.exports = __webpack_public_path__ + "img/granary3.79f1c987.png";